import { NextPage, GetStaticProps } from 'next';
import TopAuthors from '@/components/screens/top/top-authors/TopAuthors';
import { API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { ITop100Authors } from '@/interfaces/top100Authors.interface';

interface ITopsPage extends IWidgetsSideBar {
  topData: ITop100Authors;
}

const TopsAuthorsPage: NextPage<ITopsPage> = ({ topData, todayWidget, popularBooksWidget }) => {
  return <TopAuthors topData={topData} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const topDataRest = await fetch(`${API_URL}satellite/authors/top`);
  const topData = await topDataRest.json();

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { topData, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default TopsAuthorsPage;
